import { useMemo, useRef } from 'react';
import { CollectionBuilder } from './CollectionBuilder';
export function useCollection(props, factory) {
    var children = props.children;
    var factoryRef = useRef(factory);
    factoryRef.current = factory;
    return useMemo(function () {
        var builder = new CollectionBuilder();
        var nodes = builder.build({ children: children });
        return factoryRef.current(nodes);
    }, [children]);
}
